import React, { Component } from 'react';
import { SearchConditionState } from '../../../redux/reducers/SearchConditionReducer';
import { filterKeyState } from '../../../redux/reducers/CurrentFilterReducer';
import Button from '../../atoms/Button';

export interface getSearchConditionPayload {
  searchConditions: SearchConditionState;
  currentFilter: filterKeyState;
}

interface SearchConditionInputHandler {
  searchConditions: SearchConditionState;
  currentFilter: filterKeyState;
  getSearchCondition(payload: getSearchConditionPayload): string;
  getSearchConditionBadge(payload: getSearchConditionPayload): number;
}

export interface SearchConditionInputProps extends SearchConditionInputHandler {
  toggleDrower: () => void;
  searchBranchCount?: number;
  id?: string;
}

class SearchConditionInput extends Component<SearchConditionInputProps, any> {
  constructor(props: SearchConditionInputProps) {
    super(props);
    this.state = {};
  }

  render() {
    const badgeCount = this.props.getSearchConditionBadge({
      currentFilter: this.props.currentFilter,
      searchConditions: this.props.searchConditions,
    });

    return (
      <Button
        className='u-mr16'
        onClick={this.props.toggleDrower}
        type='outlined'
        leftIcon='filter_alt'
        data-testid='search-input'
        data-testid-e2e='searchConditionInput-input'
        countNumber={this.props.searchBranchCount !== 0 ? this.props.searchBranchCount : undefined}
        label='絞り込み'
        id={this.props.id}
      />
    );
  }
}

export default SearchConditionInput;
